import React from 'react';
import PropTypes from 'prop-types';
import {Col, Container, Row} from 'reactstrap';
import Card from '../../shared/Card';
import Select from '../../shared/Select';
import InfoField from '../../shared/InfoField';
import InfoInputField from '../../shared/LabeledTextInput';
import {
  DEFAULT_UOM,
  SYSTEMS_OF_MEASURE
} from '../../../constants/uom';
import {
  formatRadon,
  formatTemperature,
  formatPressure,
  formatHumidity
} from '../../../utils/formatters';

const propTypes = {
  qc: PropTypes.object,
  errors: PropTypes.object,
  defaultUom: PropTypes.string,
  editMode: PropTypes.bool,
  onFieldChange: PropTypes.func,
  onFieldValidate: PropTypes.func,
  onSwitchUom: PropTypes.func,
  showErrors: PropTypes.bool,
  qcDeviceTypes: PropTypes.array,
};

const QCTstInfo = ({
  qc = {},
  defaultUom = DEFAULT_UOM,
  editMode,
  onFieldChange,
  onFieldValidate,
  onSwitchUom,
  errors,
  showErrors,
  qcDeviceTypes
}) => {
  const uom = qc.unitOfMeasure || defaultUom;
  const units = SYSTEMS_OF_MEASURE[uom];
  return (
    <Card header='QC Test Info'>
      <Container className='px-0'>
        <Row className='text-left'>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label={`Serial Number ${editMode ? '*' : ''}`}
              value={qc.serialNumber}
              allowBlank={false}
              error={errors.qcSerialNumber}
              invalid={errors.qcSerialNumber && (showErrors || qc.serialNumber)}
              onChange={value => onFieldChange('serialNumber', value)}
              onValidate={value => onFieldValidate('qcSerialNumber', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <InfoInputField
              type='number'
              step='0.1'
              editMode={editMode}
              label={`Average Radon (${units.radon})`}
              value={qc.averageRadon}
              onChange={value => onFieldChange('averageRadon', value)}
              onBlur={() => onFieldChange('averageRadon', formatRadon(qc.averageRadon))}
            />
          </Col>
        </Row>
        <Row className='text-left'>
          <Col md={6} className='mb-3'>
            <InfoField
              editMode={editMode}
              label={`Device Type ${editMode ? '*' : ''}`}
              value={qc.deviceType}
            >
              <Select
                value={qc.deviceType}
                options={qcDeviceTypes}
                error={errors.qcDeviceType}
                invalid={errors.qcDeviceType && (showErrors || qc.deviceType)}
                allowBlank={false}
                onChange={value => onFieldChange('deviceType', value)}
                onValidate={value => onFieldValidate('qcDeviceType', value)}
              />
            </InfoField>
          </Col>
          <Col md={6} className='mb-3'>
            <InfoInputField
              type='number'
              editMode={editMode}
              label={`Average Temperature (${units.temperature})`}
              value={formatTemperature(qc.averageTemperature)}
              onChange={value => onFieldChange('averageTemperature', value)}
            />
          </Col>
        </Row>
        <Row className='text-left'>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label={`Device Model`}
              value={qc.deviceModel}
              onChange={value => onFieldChange('deviceModel', value)}
              onValidate={value => onFieldValidate('qcDeviceModel', value)}
              invalid={errors.qcDeviceModel && (showErrors || qc.deviceModel)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <InfoInputField
              type='number'
              editMode={editMode}
              label={`Average Humidity (${units.humidity})`}
              value={formatHumidity(qc.averageHumidity)}
              onChange={value => onFieldChange('averageHumidity', value)}
            />
          </Col>
        </Row>
        <Row className='text-left'>
          <Col md={6} className='mb-3'>
            <InfoField
              editMode={editMode}
              label='Units of Measure'
              value={uom}
            >
              <Select
                value={uom}
                options={Object.keys(SYSTEMS_OF_MEASURE)}
                onChange={onSwitchUom}
              />
            </InfoField>
          </Col>
          <Col md={6} className='mb-3'>
            <InfoInputField
              type='number'
              step='0.1'
              editMode={editMode}
              label={`Average Barometric Pressure (${units.pressure})`}
              value={qc.averagePressure}
              onChange={value => onFieldChange('averagePressure', value)}
              onBlur={() => onFieldChange('averagePressure', formatPressure(qc.averagePressure))}
            />
          </Col>
        </Row>
      </Container>
    </Card>
  );
};

QCTstInfo.propTypes = propTypes;

export default QCTstInfo;



// WEBPACK FOOTER //
// src/components/testDetails/QCTestInfo/index.jsx